import React, { useEffect, useState } from 'react';

/**
 * High5OnEtki: On kendi kanalını açınca High5 etkisi ve marka karması (teslim 20 Eki 2026).
 * Route: /r/high5-on-etki (sidebar YOK, tam ekran slayt, 18 slayt 16:9, Türkçe).
 * Yeniden üretmek için: node src/pages/high5-on-etki/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~85KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function High5OnEtki() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./high5OnEtkiHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="High5 · On Etki Çalışması"
      srcDoc={html}
      style={fill}
    />
  );
}
